import { v4 as uuid } from "uuid"

import { call, put, all, takeEvery, select, fork, join, delay } from "redux-saga/effects"
import {
  GET_PAGE_BY_ID,
  GET_PAGE_AND_WIDGETS_BY_PAGE_ID,
  UPDATE_PAGE,
  CREATE_WIDGETS_AND_UPDATE_PAGE,
  GET_WIDGET_DATA,
  GET_FIELD_INFOS,
  UPDATE_ONE_WIDGET,
  DELETE_WIDGETS,
  //screenshot
  SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL,
  //permission
  GET_PAGE_PERMISSION,
  CREATE_NEW_PAGE_PERMISSION,
  UPDATE_PAGE_PERMISSION,
  DELETE_PAGE_PERMISSION,
  UPDATE_PAGE_IS_PUBLIC,
  UPLOAD_BACKGROUND_PAGE,
  DUPLICATE_PAGE,
  DUPLICATE_CUBE_PAGE,
  DELETE_CUBE_PAGE,
  DELETE_FULL_PAGE,
  UPLOAD_THUMBNAIL_PAGE,
  UPLOAD_WIDGET_IMAGE_PAGE,
} from "./constants"

// Actions
import { postNotificationAction } from "Containers/Notifications/actions"
import { suiviDemandesWidgets } from "Utils/derniereDemandeWidget"
import {
  CODE_MESSAGE_COUPURE,
  DELAI_RELANCE_MS,
  estCoupureConstatee,
  marquerSiCoupure,
  MESSAGE_COUPURE_DEFAUT,
} from "Utils/erreurReseauWidget"
import {
  getPageByIdSuccess,
  getWidgetsSuccess,
  updatePageAction,
  updatePageSuccess,
  updateOneWidgetSuccess,
  getWidgetDataSuccess,
  getFieldInfosAction,
  getFieldInfosSuccess,
  setDictionaryWidgetTempNewId,
  changeSavingPageStatusAction,
  setFilterValueAction,
  duplicateCubePageAction,
  deleteCubePageAction,
  //permission
  getPagePermissionAction,
  getPagePermissionSuccess,
  updatePageIsPublicSuccess,

  // uploads
  uploadWidgetImageStatusActionPending,
  uploadWidgetImageStatusActionSuccess,
  // request status
  setWidgetRequestStatus,
} from "./actions"
import { setErrorMessage, setSuccessMessage } from "Containers/Messages/actions"

// SELECTORS
import { selectCurrentToken, selectCurrentUser, selectLangageID } from "Containers/Login/selectors.js"
import { getTranslationString } from "Utils/getTranslation"
import { selectBusiness } from "Containers/BusinessInformations/selectors"


import { getCors, postCors, postFileCors, patchCors, deleteCors } from "Utils/rulesCors"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

// Utils
import { isReferentialsBusiness } from "Components/AdminConsole/components/BusinessManagement/BusinessManagementUtils"
import { loadSagaTranslation } from "Utils/sagaTranslation"
import { getLocaleSuffix } from "Utils/translationLoader"
import { config } from "Utils/config"
import request from "Utils/request"
import {
  widgetCategory,
  formatWidgetFilterBody,
  generateETLRequestJsonFromWidgetInfo,
  getNewWidgetwithoutLongNumber,
} from "Utils/widgetsUtils.js"

import {
  generateDictioTemporary_NewId,
  getLayoutsAfterTemporaryIdReplacement,
} from "Containers/Page/page.utils.js"

import { getScreenShotFile } from "Utils/screenshotPage.js"
import { generateTemplateNotification } from "Components/Notifications/utils"

function* getPageById({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/page/${payload.pageId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getPageByIdSuccess(response.body))
    }
  } catch (err) {
    console.error("[route] => /page/:pageId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getPageAndWidgetsByPageIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const pageRequestURL = `${API_URL}/page/${payload.pageId}`
  const widgetsRequestURL = `${API_URL}/widgetsByPageId/${payload.pageId}`

  try {
    const [pageResponse, widgetsResponse] = yield all([
      call(request, pageRequestURL, getCors(specificHeaders)),
      call(request, widgetsRequestURL, getCors(specificHeaders)),
    ])
    if (pageResponse.error)
      yield yield call(manageErrorGenerator, { pageResponse, showMessageToUser: true })
    else if (widgetsResponse.error)
      yield call(manageErrorGenerator, { widgetsResponse, showMessageToUser: true })
    else {
      let actualWidget
      for (const widget of widgetsResponse.body) {
        actualWidget = widgetsResponse.body[widget]
        var widgetIsCalendar = actualWidget?.widgetType === "calendar"
        if (widgetIsCalendar) {
          var uuidFieldToGet = actualWidget?.data?.[0]?.id
          if (uuidFieldToGet) {
            yield put(
              getFieldInfosAction({
                dataCatalogueName: "defaultDataCatalogue",
                uuid: uuidFieldToGet,
                widgetId: actualWidget._id.$oid,
              })
            )
          }
        }
      }
      var embeddedWidgetsWithoutLongNumber = widgetsResponse.body
      if (Array.isArray(widgetsResponse.body)) {
        embeddedWidgetsWithoutLongNumber = widgetsResponse.body.map(widget => {
          return getNewWidgetwithoutLongNumber(widget)
        })
      }
      yield put(getPageByIdSuccess(pageResponse.body))
      yield put(getWidgetsSuccess(embeddedWidgetsWithoutLongNumber))
      if (responseTypeIsSuccess(pageResponse))
        yield call(manageSuccessGenerator, { response: pageResponse, showMessageToUser: false })
    }
  } catch (err) {
    console.error("[route] => /page/:pageId && /widgetsByPageId=> ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* updatePageSaga({ payload }) {
  const currentUser = yield select(selectCurrentUser)
  const token = yield select(selectCurrentToken)

  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)

  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`
  const notif = {
    to_principals: ["user:" + payload?.creator + ""],
    data: {
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      redirectUrl: `/page/${payload?._id?.$oid}`,
      elementInBold: `${payload?.title}`,
      event: `${trad?.A_MODIFIE_LA_PAGE}`,
      infos: ``,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.A_MODIFIE_LA_PAGE}`,
      },
    },
    ephemeral: false,
    channel_id: "dashboard_update" + localeSuffix,
  }

  const infos_notif = generateTemplateNotification("dashboard_update", {
    notif,
    currentUser,
    payload,
    trad,
  })

  try {
    const response = yield call(
      request,
      `${config?.API_URL}/page/${payload._id.$oid}`,
      patchCors(payload, { token })
    )

    if (responseTypeIsError(response)) {
      console.error("[route] => /page/:pageId => ERROR => ", response)
    } else {
      if (responseTypeIsSuccess(response)) {
        // The page header shows an inline "Saving... → Saved ✓" state, so no
        // toast is dispatched here. We still emit the DASHBOARD_SAVED successCode
        // so the Page container can react (flip to visualization mode).
        yield put(
          setSuccessMessage({
            message: "",
            code: "DASHBOARD_SAVED",
          })
        )
        yield put(updatePageSuccess(payload))
        yield put(postNotificationAction({ notif, infos_notif }))
      }
    }
  } catch (err) {
    console.error("[route] => /page/:pageId => ERROR => ", err)
  }
}

function* createWidgetsAndUpdatePageSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const { widgetsToAdd, page } = payload

  const requestURL = `${API_URL}/multipleWidgets`

  try {
    const response = yield call(request, requestURL, postCors(widgetsToAdd, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      const createdWidgets = response.body
      const dictioTemporary_NewId = generateDictioTemporary_NewId(createdWidgets)

      page.layouts = getLayoutsAfterTemporaryIdReplacement(
        { ...page.layouts },
        dictioTemporary_NewId
      )
      if (page.fixedLayouts)
        page.fixedLayouts = getLayoutsAfterTemporaryIdReplacement(
          { ...page.fixedLayouts },
          dictioTemporary_NewId
        )

      yield put(updatePageAction(page)) // update remote page
      yield put(setDictionaryWidgetTempNewId(dictioTemporary_NewId))

      // Sync each created widget into Redux actualPage.widgets so visualization
      // mode shows them immediately without a page refresh.
      if (Array.isArray(createdWidgets)) {
        for (const widget of createdWidgets) {
          yield put(updateOneWidgetSuccess(widget))
        }
      }

      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
    }
  } catch (err) {
    console.error("[route] => /page/:pageId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* updateWidgetSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const path = `/widget/${payload._id.$oid}`
  const requestURL = `${API_URL}${path}`

  try {
    const response = yield call(request, requestURL, patchCors(payload, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      // Sync Redux with the saved widget so visualization mode shows the new config
      // without requiring a page refresh. Use the payload (already merged client-side)
      // since the PATCH endpoint typically returns only a confirmation.
      yield put(updateOneWidgetSuccess(payload))
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deleteWidgetsSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const { widgetsIdToDelete, pageId } = payload
  const requestURL = `${API_URL}/deleteWidgets`

  var objectToSend = {
    widgetsIdToDelete: widgetsIdToDelete,
    pageId,
  }
  try {
    const response = yield call(request, requestURL, postCors(objectToSend, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] => /deleteWidgets => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

const logRequestDuration = (reqId, widgetId, start, end) => {
  console.log(`requestId: ${reqId} - widgetId: ${widgetId} took ${parseInt(end - start)} ms.`)
}

const RELANCE_ABANDONNEE = Symbol("relance abandonnée")

/**
 * Appel ETL d'un widget, relancé UNE fois sur coupure réseau (`Utils/erreurReseauWidget`).
 * Pas de relance pour une erreur renvoyée par le serveur, ni pour une requête déjà dépassée.
 * Rend `RELANCE_ABANDONNEE` si une demande plus récente est partie pendant le délai.
 */
function* requeteWidgetAvecUneRelance(widgetId, requestId, url, options) {
  try {
    return yield call(request, url, options)
  } catch (err) {
    // Le marqueur dit au `catch` de la saga que l'échec vient bien du réseau.
    if (!marquerSiCoupure(err) || !suiviDemandesWidgets.estLaDerniere(widgetId, requestId)) throw err
  }
  yield delay(DELAI_RELANCE_MS)
  if (!suiviDemandesWidgets.estLaDerniere(widgetId, requestId)) return RELANCE_ABANDONNEE
  try {
    return yield call(request, url, options)
  } catch (err) {
    marquerSiCoupure(err)
    throw err
  }
}

// Exportée pour les tests : `utils/__tests__/derniereDemandeWidget.test.js`.
export function* getWidgetDataSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const { widgetId, _, body } = payload
  const dashboardId = payload?.dashboardId
  const requestURL = `${config.APOLLO_SERVER_URL}/etl/dashboard/${dashboardId}/request`
  const requestId = uuid()
  const bodyToUse = { ...body, requestId: requestId }
  const start = performance.now()
  // Cette requête devient la dernière demande du widget : une réponse plus ancienne qui
  // arriverait après elle sera ignorée, sauf si elle répondait à la MÊME requête
  // (`Utils/derniereDemandeWidget`).
  const cleRequete = JSON.stringify(body ?? null)
  suiviDemandesWidgets.noter(widgetId, requestId, cleRequete)

  // Marquer le widget comme en cours de chargement sans bloquer
  yield put(setWidgetRequestStatus({ widgetId: widgetId, status: "PENDING" }))

  try {
    // Une coupure réseau est relancée une fois (`Utils/erreurReseauWidget`).
    const response = yield call(
      requeteWidgetAvecUneRelance,
      widgetId,
      requestId,
      requestURL,
      postCors(bodyToUse, { Authorization: `Bearer ${token}` })
    )
    // Une demande plus récente est arrivée pendant l'attente de la relance : rien à appliquer.
    if (response === RELANCE_ABANDONNEE) return
    const end = performance.now()
    logRequestDuration(requestId, widgetId, start, end)

    // Réponse PÉRIMÉE : une demande DIFFÉRENTE et plus récente est partie pour ce widget. Elle ne
    // touche ni aux données, ni aux options de la liste, ni au statut, et n'affiche aucun message.
    // Une réponse à une requête IDENTIQUE à la dernière demande s'applique, elle : c'est la bonne
    // réponse, arrivée plus tôt (doublon d'ouverture de page).
    if (!suiviDemandesWidgets.estApplicable(widgetId, requestId, cleRequete)) return

    if (responseTypeIsError(response)) {
      console.error("Erreur lors de la récupération des données de widget:", response)
      yield fork(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setWidgetRequestStatus({ widgetId: widgetId, status: "ERROR" }))
    } else {
      // Gestion du succès sans bloquer les appels simultanés
      yield fork(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(setWidgetRequestStatus({ widgetId: widgetId, status: "SUCCESS" }))

      /**
       * Une réponse PÉRIMÉE n'écrase ni les données du widget, ni les options de sa liste : elle est
       * écartée plus haut, avant toute écriture. Les filtres dépendants réémettent TOUTES les
       * requêtes d'options à chaque sélection : sans cette garde, deux changements rapprochés
       * suffisaient à laisser une liste sur un état de filtrage qui n'a plus cours.
       *
       * ⚠️ L'ancienne garde comparait l'en-tête `x-request-date`, que l'ETL n'envoie pas : elle
       * laissait tout passer. `requestDate` est conservé pour le réducteur, qui l'ignore s'il est vide.
       */
      const newRequestDate = response["x-request-date"]
      yield put(
        getWidgetDataSuccess({
          widgetId: widgetId,
          columns: response.body.columns,
          data: response.body.data,
          requestDate: newRequestDate,
        })
      )

      if (["dropdownList", "rangeFilter", "searchBar"].includes(payload?.widgetType)) {
        // `multiValueSeparator` : le widget déclare que ses cellules portent plusieurs valeurs
        // jointes, et qu'il faut donc une option par valeur et non par combinaison.
        const bodyToReturn = formatWidgetFilterBody(
          response.body.data,
          payload?.multiValueSeparator,
          payload?.outputToField,
          payload?.optionLabel
        )
        yield put(
          getFieldInfosSuccess({
            widgetId: widgetId,
            body: bodyToReturn,
          })
        )
      }
    }
  } catch (err) {
    const end = performance.now()
    logRequestDuration(requestId, widgetId, start, end)
    // Échec d'une requête déjà dépassée : la demande récente porte le statut du widget.
    if (!suiviDemandesWidgets.estLaDerniere(widgetId, requestId)) return
    console.error(`[route] => ${requestURL} => ERROR => `, err)
    yield put(setWidgetRequestStatus({ widgetId: widgetId, status: "ERROR" }))
    if (estCoupureConstatee(err)) {
      // Coupure persistante après la relance : UN message pour toute la page, dédoublonné par
      // son code — une grappe de coupures en affichait jusqu'à 28.
      const langageId = yield select(selectLangageID)
      const message =
        getTranslationString(CODE_MESSAGE_COUPURE, langageId) || MESSAGE_COUPURE_DEFAUT
      yield put(setErrorMessage({ code: CODE_MESSAGE_COUPURE, message }))
    } else {
      yield put(setErrorMessage(err))
    }
  }
}

///////////////////////////////////////

function* getFieldInfosSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const { widgetId, dataCatalogueName, uuid } = payload
  const encodedUuid = encodeURIComponent(uuid)
  const path = `/v1/datacatalogues/${dataCatalogueName}/fields/${encodedUuid}/info`
  const requestURL = `${API_URL}${path}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(
        getFieldInfosSuccess({
          widgetId: widgetId,
          body: { unique: response.body.unique },
        })
      )
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* takeScreenShotThumbnailSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/images/upload"

  const { pageId, uploadNumber } = payload

  const file = yield call(() => {
    return getScreenShotFile("pageGridLayoutContainer", pageId)
  })

  const formData = new FormData()
  formData.append("file", file)
  formData.append("uploadType", "pageThumbnail")
  formData.append("pageId", pageId)
  formData.append("uploadNumber", uploadNumber)

  try {
    yield put(changeSavingPageStatusAction("SCREENSHOT_PENDING"))
    const response = yield call(request, requestURL, postFileCors(formData, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (response?.code === "SUCCESS_TO_UPLOAD_IMAGE") {
        yield put(changeSavingPageStatusAction("SCREENSHOT_DONE"))
      } else {
        yield put(changeSavingPageStatusAction("SCREENSHOT_FAIL"))
      }
      // var imgData = arrayBufferToBase64(response.body.data)
      // window.localStorage.setItem("businessLogo", imgData)
      // if (responseTypeIsSuccess(response)) yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      // var actualDate = parseInt(Date.now()/1000)
      // yield put(uploadBusinessLogoSuccess(actualDate))
    }
  } catch (err) {
    console.error("[route] --> /images/upload | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* getPagePermissionSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const { pageId } = payload
  const path = `/pagePermissionByPageId/${pageId}`
  const requestURL = `${API_URL}${path}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getPagePermissionSuccess(response.body))
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* createNewPagePermissionSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const { permission, pageId } = payload
  const path = `/pagePermission`
  const requestURL = `${API_URL}${path}`

  try {
    const response = yield call(request, requestURL, postCors(permission, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getPagePermissionAction({ pageId: pageId }))
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* updatePagePermissionSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const { permission, pageId } = payload
  const pagePermissionId = permission._id.$oid
  const path = `/pagePermission/${pagePermissionId}`
  const requestURL = `${API_URL}${path}`

  try {
    const response = yield call(request, requestURL, patchCors(permission, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getPagePermissionAction({ pageId: pageId }))
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deletePagePermissionSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const { pagePermissionId, pageId } = payload
  const path = `/pagePermission/${pagePermissionId}`
  const requestURL = `${API_URL}${path}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getPagePermissionAction({ pageId: pageId }))
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* updatePageIsPublicSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  const { API_URL } = config
  const { pageId, isPublic } = payload
  const path = `/page/${pageId}`
  const requestURL = `${API_URL}${path}`

  try {
    const response = yield call(
      request,
      requestURL,
      patchCors({ _id: { $oid: pageId }, isPublic }, { token })
    )
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(updatePageIsPublicSuccess({ isPublic }))
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deleteFullPageSaga({ payload }) {
  const currentUser = yield select(selectCurrentUser)
  const token = yield select(selectCurrentToken)

  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)
  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`

  const notif = {
    to_principals: ["user:" + payload?.page?.creator + ""],
    data: {
      event: `${trad?.A_SUPPRIME_LA_PAGE}`,
      elementInBold: `${payload.page.title}`,
      redirectUrl: ``,
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      infos: ``,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.A_SUPPRIME_LA_PAGE}`,
      },
    },
    ephemeral: false,
    channel_id: "dashboard_delete" + localeSuffix,
  }

  const infos_notif = generateTemplateNotification("dashboard_delete", {
    notif,
    currentUser,
    payload,
    trad,
  })

  try {
    const response = yield call(
      request,
      `${config?.API_URL}/clearFullPage/${payload?.pageId}`,
      deleteCors({ token })
    )
    if (responseTypeIsError(response)) {
      console.error(`[route] => /clearFullPage/:pageId => ERROR => `, response)
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(deleteCubePageAction({ dashboardId: payload?.pageId, token }))
        yield put(postNotificationAction({ notif, infos_notif }))
      }
    }
  } catch (err) {
    console.error(`[route] => /clearFullPage/:pageId => ERROR => `, err)
  }
}

function* duplicatePageSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const { pageId, folder } = payload
  const path = `/duplicatePage/${pageId}`
  const requestURL = `${API_URL}${path}`
  const emptyBody = {}

  try {
    const response = yield call(request, requestURL, postCors(emptyBody, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      // IF WE DUPLICATE IN A REPO >>
      if (folder) {
        const newPageId = response?.body?.newPageIdCreated
        const folderWithNewPage = {
          folderId: folder?._id?.$oid,
          editedFolder: {
            pageList: [...folder?.pageList, newPageId],
          },
        }
        // yield put(editPageFolderAction(folderWithNewPage)) Désactivé temporairement
      }
      yield put(
        duplicateCubePageAction({
          fromDashboard: pageId,
          toDashboardId: response?.body?.newPageIdCreated,
          Authorization: `Bearer ${token}`,
        })
      )
    }
  } catch (err) {
    console.error(`[route] => ${path} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* duplicateCubePageSaga({ payload }) {
  const requestURL = `${config?.APOLLO_SERVER_URL}/etl/dashboard/copy`

  try {
    const response = yield call(request, requestURL, postCors({ ...payload }))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })
    }
  } catch (err) {
    console.error(`[route] => /dashboard/copy => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deleteCubePageSaga({ payload }) {
  const requestURL = `${config?.APOLLO_SERVER_URL}/etl/dashboard/delete/${payload?.dashboardId}`

  try {
    const response = yield call(
      request,
      requestURL,
      deleteCors({ Authorization: `Bearer ${payload?.token}` })
    )
    console.log("response", response)
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })
    }
  } catch (err) {
    console.error(`[route] => /etl/dashboard/delete/${payload?.dashboardId} => ERROR => `, err)
    // yield put(setErrorMessage(err))
  }
}

function* uploadBackgroundPage({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/images/upload"

  const { pageId, uploadNumber } = payload

  const formData = new FormData()
  formData.append("file", payload.file)
  formData.append("uploadType", "pageBackground")
  formData.append("pageId", pageId)
  formData.append("uploadNumber", uploadNumber)

  try {
    const response = yield call(request, requestURL, postFileCors(formData, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      // var imgData = arrayBufferToBase64(response.body.data)
      // window.localStorage.setItem("businessLogo", imgData)
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] --> /images/upload | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* uploadThumnailPage({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/images/upload"

  const { pageId, uploadNumber } = payload

  const formData = new FormData()
  formData.append("file", payload.file)
  formData.append("uploadType", "pageThumbnail")
  formData.append("pageId", pageId)
  formData.append("uploadNumber", uploadNumber)

  try {
    const response = yield call(request, requestURL, postFileCors(formData, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      // var imgData = arrayBufferToBase64(response.body.data)
      // window.localStorage.setItem("businessLogo", imgData)
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] --> /images/upload | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* uploadWidgetImage({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/images/upload"

  const { isTemp, widgetId } = payload

  const formData = new FormData()
  formData.append("file", payload.file)
  formData.append("uploadType", "workingWidgets")
  formData.append("widgetId", widgetId)

  try {
    // créer action pour passer uploadStatus en IN PROGRESS
    yield put(uploadWidgetImageStatusActionPending())
    const response = yield call(request, requestURL, postFileCors(formData, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      // var imgData = arrayBufferToBase64(response.body.data)
      // window.localStorage.setItem("businessLogo", imgData)
      if (response?.widgetImageUploadSuccess) yield put(uploadWidgetImageStatusActionSuccess())
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] --> /images/upload | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* pageSaga() {
  yield takeEvery(GET_PAGE_BY_ID, getPageById)
  yield takeEvery(GET_PAGE_AND_WIDGETS_BY_PAGE_ID, getPageAndWidgetsByPageIdSaga)
  yield takeEvery(UPDATE_PAGE, updatePageSaga)
  yield takeEvery(CREATE_WIDGETS_AND_UPDATE_PAGE, createWidgetsAndUpdatePageSaga)
  yield takeEvery(UPDATE_ONE_WIDGET, updateWidgetSaga)
  yield takeEvery(DELETE_WIDGETS, deleteWidgetsSaga)
  yield takeEvery(GET_WIDGET_DATA, getWidgetDataSaga)
  yield takeEvery(GET_FIELD_INFOS, getFieldInfosSaga)
  //SCREENSHOT
  yield takeEvery(SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL, takeScreenShotThumbnailSaga)
  //PERMISSION
  yield takeEvery(GET_PAGE_PERMISSION, getPagePermissionSaga)
  yield takeEvery(CREATE_NEW_PAGE_PERMISSION, createNewPagePermissionSaga)
  yield takeEvery(UPDATE_PAGE_PERMISSION, updatePagePermissionSaga)
  yield takeEvery(DELETE_PAGE_PERMISSION, deletePagePermissionSaga)
  yield takeEvery(UPDATE_PAGE_IS_PUBLIC, updatePageIsPublicSaga)
  //DELETE FULL PAGE
  yield takeEvery(DELETE_FULL_PAGE, deleteFullPageSaga)
  yield takeEvery(DUPLICATE_PAGE, duplicatePageSaga)
  yield takeEvery(DUPLICATE_CUBE_PAGE, duplicateCubePageSaga)
  yield takeEvery(DELETE_CUBE_PAGE, deleteCubePageSaga)
  // UPLOADS
  yield takeEvery(UPLOAD_BACKGROUND_PAGE, uploadBackgroundPage)
  yield takeEvery(UPLOAD_THUMBNAIL_PAGE, uploadThumnailPage)
  yield takeEvery(UPLOAD_WIDGET_IMAGE_PAGE, uploadWidgetImage)
}

export default pageSaga
